const ALERT = 'alert';
const ERROR = 'error';
const NOTICE = 'notice';
const SUCCESS = 'success';
export const FLASH_TYPES = {
  [ALERT]: ALERT,
  [ERROR]: ERROR,
  [NOTICE]: NOTICE,
  [SUCCESS]: SUCCESS,
};
